<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="member"
          :title="title"
          :url="url"
          :columns="columns"
          :filter="filter"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :disable-action="true"
          :action-width="180"
        >
          <template
            v-if="canEdit && !loading"
            v-slot:action
          >
            <v-col md="3">
              <v-btn
                depressed
                class="ma-1"
                color="primary"
                small
                @click="onClickCreate()"
              >
                <v-icon small left>mdi-plus</v-icon>
                Tambah
              </v-btn>
            </v-col>
          </template>
          <template v-slot:item.roles="{ item }">
            {{ item.roles_name.join(", ") }}
          </template>
        </datatable>
      </div>
    </div>
    <form-member-referral ref="formMemberReferral" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="member-referral"
      :success="deleteSuccess"
    ></delete-dialog>
  </div>
</template>

<script>
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormMemberReferral from "./FormMemberReferral.vue";

export default {
  data() {
    return {
      title: "Member Referral",
      url: "member-referral/data?id=" + this.id,
      columns: [
        {
          value: "id"
        },
        {
          text: "Member yang di referensikan",
          value: "referred_member_name",
          sortable: true,
          searchable: true
        },
        {
          text: "Free Month",
          value: "free_month",
          sortable: true,
          searchable: false
        },
        {
          text: "Created At",
          value: "created_at",
          sortable: true,
          searchable: false
        },
       
        
      ],
      data: [],
      loading: true,
      filter: null
    };
  },
  props: {
    id: String,
    canEdit: Boolean
  },
  methods: {
    onClickCreate() {
      this.$refs.formMemberReferral.open(this.id);
    },
    onClickUpdate(item) {
      this.$refs.formMemberReferral.open(this.id, item.id);
    },
    onClickDelete(item) {
      this.$refs.delete.open(item.id);
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    },
    setDefaultFilter() {
      this.filter = [
        {
          column: "member_id",
          value: this.id,
          operator: "eq",
        },
      ];
    },

  },
  mounted() {

    this.setDefaultFilter();
    this.$watch(
      () => {
        return this.$refs.datatable.items;
      },
      val => {
        this.data = val;
        this.loading = false;
      }
    );
  },
  components: {
    Datatable,
    DeleteDialog,
    FormMemberReferral
  }
};
</script>
